<template>
  <router-link
    v-if="clickable !== false"
    :to="{
      name: 'SolutionsItem',
      params: { lang: $i18n.locale, itemId: itemId },
    }"
    class="product-card-link"
  >
    <base-card
      class="mx-3 clickable-card"
      :title="title"
      :subtitle="desc"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <base-img
        v-if="src"
        :aspect-ratio="4/3"
        :src="src"
        :alt="title"
        class="product-cover-img"
        contain
      />
    </base-card>
  </router-link>
  <div
    v-else
    class="product-card-wrapper not-clickable"
    @click.stop="handleNotClickable"
  >
    <base-card
      class="mx-3"
      :title="title"
      :subtitle="desc"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <base-img
        v-if="src"
        :aspect-ratio="4/3"
        :src="src"
        :alt="title"
        class="product-cover-img"
        contain
      />
    </base-card>
  </div>
</template>

<script>
  export default {
    name: 'SolutionCard',

    inheritAttrs: false,

    props: {
      src: String,
      title: String,
      desc: String,
      itemId: {
        type: [String, Number],
        default: 1,
      },
      clickable: {
        type: Boolean,
        default: true,
      },
    },

    methods: {
      handleNotClickable() {
        const message = this.$t('solutions.contact_business') || '请联系商务了解方案详情'
        const actionText = this.$t('contact.title')

        if (this.$root.$showSnackbar) {
          this.$root.$showSnackbar({
            message: message,
            color: 'info',
            timeout: 3000,
            actionText: actionText,
            actionCallback: () => {
              this.navigateToHomeAndScroll()
            },
          })
        }
      },

      navigateToHomeAndScroll() {
        const isOnHomePage = this.$route.name === 'Home'

        const scrollToBottom = () => {
          this.$nextTick(() => {
            setTimeout(() => {
              window.scrollTo({
                top: document.documentElement.scrollHeight + 500,
                behavior: 'smooth',
              })
            }, 1000)
          })
        }

        if (!isOnHomePage) {
          this.$router.push({ name: 'Home', params: { lang: this.$i18n.locale } }).then(() => {
            scrollToBottom()
          }).catch(() => {
            scrollToBottom()
          })
        } else {
          scrollToBottom()
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
  .product-cover-img
    border: thin solid rgba(0, 0, 0, .12)

  .product-card-link
    text-decoration: none
    color: inherit
    display: block

  .clickable-card
    cursor: pointer

  .product-card-wrapper.not-clickable
    cursor: pointer

</style>
